import i18n, { t } from 'i18next';

// Literal English HttpError details of the Raben flows (backend, not
// gettext-wrapped) -> translation key in `apiErrors`. Unknown details stay
// as they are. Source rows: qp-artifacts 20261103-envirly-raben E3 4.4, 2.6.
export const apiErrorKeys: Record<string, string> = {
  'VAT identifier is required': 'vatRequired',
  'Survey not found': 'surveyNotFound',
  'Organization VAT identifier is missing': 'orgVatMissing',
  'raben_root tag is not configured': 'rabenRootNotConfigured',
  'raben_root organization is not configured': 'rabenRootNotConfigured',
  'raben_root organization is missing CO2 profile': 'rabenRootNotConfigured',
  'Survey already exists but in a different branch': 'surveyOtherBranch',
  "Only the carrier's own users can make this decision": 'carrierOnlyDecision',
  'Supplier Commitment Letter must be accepted before setting a target':
    'commitmentLetterRequired',
  'expected_base_emissions must be a finite number': 'invalidBaseEmissions',
  stale_preview: 'stalePreview',
  'The emission reduction target has already been set': 'targetAlreadySet',
  'Invalid token': 'invalidToken',
  'Missing consents': 'missingConsents',
  'Required consents not accepted': 'missingConsents',
  'Invalid credentials': 'invalidCredentials',
  'Invalid refresh token': 'sessionExpired',
  'Invalid access token': 'sessionExpired',
  Unauthenticated: 'sessionExpired',
  'User does not have access to specified organizations': 'noOrgAccess',
  'This organization does not exist or is not assigned to this user':
    'orgNotFound',
  'Organization not found': 'orgNotFound',
  'Onboarding has not been completed': 'onboardingNotCompleted',
  'Onboarding has been completed': 'onboardingCompleted',
  'Invalid period format': 'invalidPeriod',
  'Scope 1/2 is locked until platform option is selected for this year':
    'scopeLocked',
  'Insufficient permissions': 'insufficientPermissions',
  'Cannot delete root organization': 'cannotDeleteRootOrg',
  'Password already set': 'passwordAlreadySet',
  'Too soon to resend the invitation': 'resendTooSoon',
  'No code of conduct file uploaded': 'noCodeOfConductFile',
  // global IntegrityError handler, backend/backend/apis/__init__.py
  'Resource already exists': 'resourceExists',
  'This resource cannot be deleted, because it is in use by other resources.':
    'resourceInUse',
  'Invalid data': 'invalidData',
};

// f-string details: the embedded values are not shown to the user.
const apiErrorPatterns: [RegExp, string][] = [
  [/^base_year \d+ is not eligible /, 'baseYearNotEligible'],
  [/^Invalid consent key, not in /, 'invalidConsentKey'],
  [
    /^The specified user does not have access to the organization's '.*' module\.$/,
    'noModuleAccess',
  ],
];

export const apiErrorKey = (detail: string): string | undefined =>
  apiErrorKeys[detail] ??
  apiErrorPatterns.find(([pattern]) => pattern.test(detail))?.[1];

// Only ro is translated; every other language shows the backend detail as is.
export const translateApiError = (detail: string): string => {
  const lang = i18n.resolvedLanguage ?? i18n.language;
  if (!lang?.startsWith('ro')) return detail;
  const key = apiErrorKey(detail);
  return key ? t(`apiErrors.${key}`) : detail;
};
